module.exports = __webpack_public_path__ + "public/images/employee-item.92731a1085c1dcade1b3e7b62a2efd6a.svg";